import * as React from 'react';

export const CancelledIcon = () => {
  return (
    <svg
      width={32}
      height={32}
      viewBox="0 0 32 32"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>{'2D83D394-2F8A-46D5-A2D8-E68D3FD69DFD@1x'}</title>
      <path
        d="M16 0c8.837 0 16 7.163 16 16s-7.163 16-16 16S0 24.837 0 16 7.163 0 16 0zm7 8H9a1 1 0 00-1 1v14a1 1 0 001 1h14a1 1 0 001-1V9a1 1 0 00-1-1zm-.5 2.56V22.5H10.56L22.5 10.56zM21.438 9.5L9.5 21.438V9.5h11.938z"
        fill="#D11053"
        fillRule="evenodd"
      />
    </svg>
  );
};
